import { NavLink, Link } from "react-router-dom";
import { FaBlog, FaBars, FaHome, FaSignInAlt, FaUserCheck } from "react-icons/fa";
import { Drawer } from "antd";
import { MdPeople } from "react-icons/md";
import { FaTableList, FaUserDoctor } from "react-icons/fa6";
import { RiPsychotherapyFill } from "react-icons/ri";

const HeaderNav = ({ open, setOpen, isLoggedIn }) => {
  const showDrawer = () => setOpen(true);
  const onClose = () => setOpen(false);

  return (
    <>
      {/* Desktopowa nawigacja */}
      <nav id="navbar" className="navbar d-none d-lg-flex">
        <ul>
          <li><NavLink to={"/"}>STRONA GŁÓWNA</NavLink></li>
          <li><NavLink to={"/blog"}>BLOG</NavLink></li>
          <li><NavLink to={"/o-nas"}>O NAS</NavLink></li>
          <li><NavLink to={"/oferta"}>OFERTA</NavLink></li>
          <li><NavLink to={"/specjalisci"}>SPECJALIŚCI</NavLink></li>
          <li><NavLink to={"/cennik"}>CENNIK</NavLink></li>
        </ul>
      </nav>

      {/* Ikona hamburgera – wyśrodkowana na mobile w CSS */}
      <FaBars
        className="mobile-nav-toggle d-lg-none"
        onClick={showDrawer}
        aria-label="Otwórz menu"
        role="button"
      />

      {/* Pełnoekranowy Drawer na mobile */}
      <Drawer
        placement="left"
        width="100vw"
        onClose={onClose}
        open={open}
        bodyStyle={{ padding: "20px", height: "100vh", overflow: "auto" }}
        rootClassName="mobile-fullscreen-drawer"
      >
        <ul className="mobile-menu-nav">
          <li><NavLink to={"/"} onClick={onClose}><FaHome className="icon" /> STRONA GŁÓWNA</NavLink></li>
          <li><NavLink to={"/blog"} onClick={onClose}><FaBlog className="icon"/> BLOG</NavLink></li>
          <li><NavLink to={"/o-nas"} onClick={onClose}><MdPeople className="icon" /> O NAS</NavLink></li>
          <li><NavLink to={"/oferta"} onClick={onClose}><RiPsychotherapyFill className="icon" /> OFERTA</NavLink></li>
          <li><NavLink to={"/specjalisci"} onClick={onClose}><FaUserDoctor className="icon" /> SPECJALIŚCI</NavLink></li>
          <li><NavLink to={"/cennik"} onClick={onClose}><FaTableList className="icon" /> CENNIK</NavLink></li>

          {/* Dodatkowe opcje przeniesione do HeaderNav na mobile */}
          <li><NavLink to={"/umow-wizyte"} onClick={onClose}><RiPsychotherapyFill className="icon" /> UMÓW WIZYTĘ</NavLink></li>

          {isLoggedIn ? (
            <li><NavLink to={"/dane-uzytkownika"} onClick={onClose}><FaUserCheck className="icon" /> MÓJ PROFIL</NavLink></li>
          ) : (
            <li><Link to={"/login"} onClick={onClose}><FaSignInAlt className="icon" /> ZALOGUJ SIĘ</Link></li>
          )}
        </ul>
      </Drawer>
    </>
  );
};

export default HeaderNav;
